import script from "./TicketDocumentsField.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketDocumentsField.vue?vue&type=script&setup=true&lang=js"

import "./TicketDocumentsField.vue?vue&type=style&index=0&id=ec027e94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec027e94"]])

export default __exports__